class DBProductForm extends HTMLElement{
  connectedCallback(){
    this.form=this.querySelector('form');
    this.variantInput=this.querySelector('[name="id"]');
    this.price=this.querySelector('[data-product-price]');
    this.add=this.querySelector('[data-add-button]');
    this.mainImage=document.querySelector('[data-main-product-image]');
    try{this.variants=JSON.parse(this.querySelector('[data-variants-json]').textContent)}catch(e){this.variants=[]}
    this.addEventListener('change',()=>this.updateVariant());
    this.updateVariant();
  }
  selectedOptions(){
    return Array.from(this.querySelectorAll('fieldset')).map(fs=>{
      const checked=fs.querySelector('input[type="radio"]:checked');
      return checked?checked.value:null;
    });
  }
  updateVariant(){
    const selected=this.selectedOptions();
    const variant=this.variants.find(v=>v.options.every((o,i)=>o===selected[i]));
    if(!variant){
      if(this.add){this.add.disabled=true;this.add.textContent='Ej tillgänglig'}
      return;
    }
    if(this.variantInput)this.variantInput.value=variant.id;
    if(this.add){this.add.disabled=!variant.available;this.add.textContent=variant.available?'Lägg i varukorg':'Slutsåld'}
    if(this.price && variant.price){this.price.textContent=this.formatMoney(variant.price)}
    if(this.mainImage && variant.featured_image && variant.featured_image.src){
      this.mainImage.src=variant.featured_image.src;
    }
    const url=new URL(window.location.href);url.searchParams.set('variant',variant.id);history.replaceState({},'',url.toString());
  }
  formatMoney(cents){
    return new Intl.NumberFormat('sv-SE',{style:'currency',currency:'SEK',maximumFractionDigits:0}).format(cents/100);
  }
}
customElements.define('db-product-form', DBProductForm);

document.addEventListener('click',e=>{
  const btn=e.target.closest('[data-product-thumb]');
  if(!btn)return;
  const img=document.querySelector('[data-main-product-image]');
  if(img && btn.dataset.src) img.src=btn.dataset.src;
});
